import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isDosenOrMahasiswa } from "../../../../utils/helpers/roles.helpers";
import { toTitleCase } from "../../../../utils/helpers/common.helpers";
import Auth from "../../../../services/Auth/Auth";
import CustomLink from "./CustomLink";
import moment from "moment";
import Countdown from "react-countdown";

export default function UserDropdown() {
  const navigate = useNavigate();
  const interval = useRef();
  let user = Auth.getCurrentUser();
  const [tokenExpiry, setTokenExpiry] = useState(null);

  useEffect(() => {
    interval.current = setInterval(() => {
      let currentUser = Auth.getCurrentUser();
      if (!currentUser) return;
      let expiryDate = moment(currentUser.expires_at);
      if (!tokenExpiry || expiryDate.isAfter(tokenExpiry)) {
        setTokenExpiry(String(expiryDate));
      }
    }, 1000);
    return () => clearInterval(interval.current);
  }, []);

  return (
    <div className="dropdown pr-4 pl-3 w-full font-medium rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 inline-block">
      <button className="flex items-center rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 ">
        <span className="font-bold">{user ? user.name : "No Name"}</span>
        <svg
          className="inline ml-1 w-5 h-5"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </button>
      <ul className="dropdown-menu absolute right-3 md:right-auto hidden bg-white text-white-700 rounded-md border-solid border border-grey-200 shadow">
        {isDosenOrMahasiswa(user) && (
          <>
            <li>
              <CustomLink
                itemkey="profil"
                to="/profil"
                className="text-inherit"
              >
                <span className="bg-white hover:bg-gray-200 hover:text-blue-700 py-2 px-4 block whitespace-no-wrap">
                  Profil
                </span>
              </CustomLink>
            </li>
            <hr />
          </>
        )}
        <li>
          <div className="flex flex-col px-4 py-2 text-black">
            <div>Otomatis Keluar: </div>
            <div>
              {tokenExpiry !== null ? (
                <Countdown date={tokenExpiry} daysInHours={false} />
              ) : (
                ""
              )}
            </div>
          </div>
        </li>
        <li>
          <button
            onClick={() => {
              Auth.logout();
              if (window.location.pathname === "/") {
                window.location.reload();
              } else {
                navigate("/", { replace: true });
              }
            }}
            className="flex gap-1 w-full m-0 py-2 px-4 text-red-500 font-semibold fill-red-500 hover:bg-red-500 hover:text-white hover:border-transparent hover:fill-white rounded-b-md"
          >
            <svg
              className="fill-inherit"
              height="20"
              viewBox="0 0 20 20"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="M3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17C3.55228 17 4 16.5523 4 16V4C4 3.44772 3.55228 3 3 3ZM13.2929 12.2929C12.9024 12.6834 12.9024 13.3166 13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071L17.7071 10.7071C17.8946 10.5196 18 10.2652 18 10C18 9.73478 17.8946 9.48043 17.7071 9.29289L14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289C12.9024 6.68342 12.9024 7.31658 13.2929 7.70711L14.5858 9L7 9C6.44771 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H14.5858L13.2929 12.2929Z"
                fill="inherit"
                fillRule="evenodd"
              />
            </svg>
            <span>Keluar</span>
          </button>
        </li>
      </ul>
    </div>
  );
}
